import React from 'react';
import MainMarazone from '../../components/Main/MainMarazone';

const MainPage = () => {
    return (
        <div>
            <MainMarazone/>            
        </div>
    );
};

export default MainPage;